import UsersManagement from '@src/main/modules/user/ui/components/UsersManagement';

const UsersManagementPage = () => <UsersManagement />;

export default UsersManagementPage;
